export const PROMOTIONS = [
    {
      id: 0,
      name: 'Navy Blue Kurta',
      image: '/assets/images/w2.jpg',
      label: 'New',
      price: '19.99',
      featured: true,
      description: 'Featuring mouthwatering combinations with a choice of five different salads, six enticing appetizers, six main entrees and five choicest desserts. Free flowing bubbly and soft drinks. All for just $19.99 per person'
    }
  ];